import type { Project } from "./projects";

/** Bright, vivid category colours — the palette's source of life on dark. */
export const categoryColor: Record<Project["category"], string> = {
  "Leading now": "#37d67a",
  Industry: "#4d7cff",
  University: "#b06cff",
  Personal: "#ff9838",
};
